import React from 'react';
import { Grid } from '@mui/material';

export default function Header() {
    return (
        <Grid container item flexDirection={'column'} justifyContent={'center'}>
            <Grid container item justifyContent={'center'} fontSize={40} marginTop={2}>{'The Wash 360'}</Grid>
            <Grid container item justifyContent={'center'} fontSize={32}>{'全方位洗車'}</Grid>
        </Grid>
    );
}
